export default __webpack_public_path__ + "static/media/DigitInsurance.c3ebb064.svg";